module.exports = __webpack_public_path__ + "img/Time.dea0a16a.svg";